import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import Mask from 'utils/src/mask';

import ContentCard from 'components/ContentCard/index';
import { Layout } from 'components';
import { Col, Row } from 'components/Grid';
import Label from "components/Form/Label";
import InputField from "components/Form/InputField";
import SelectField from "components/Form/SelectField";
import SearchField from "components/Form/SearchField";
import CheckBox from "components/Form/CheckBox";
import { RadioButtonGroup } from "components/Form/Radio/index";
import { MultiSelectField } from "components/Form/index";
import { Button } from 'components/index';
import Subtitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import LogoFator from 'components/Icon/png/Icon_Logo_Fator.png';
import LogoArgo from 'components/Icon/png/Icon_Logo_Argo.png';
import { Content, ButtonContainer, Fieldset, CardInfo, Logo, Line, AceptContainer, CalendarContainer } from './styles';
import Modal from 'components/Modal/index';


export default function PaymentPage(props) {

  const [validation, setValidation] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [insurer, setInsurer] = useState('');
  const [questions, setQuestions] = useState([]);
  const [quote, setQuote] = useState({
    idOperation: "",
    proponent: "",
    email: "",
    cpfOrCnpj: "",
    previousInsurer: "",
    susep: "",
    marketingBranches: [],
    sufferedComplaintsFiveYears: "",
    possibleComplaints: "",
    effectiveDate: "",
    retroactivity: "",
    annualBilling: "",
    transportBilling: "",
    product_plans: [],
    coverages: [],
    limits: [],
    installmentNumber: {}
  });
  const [plan, setPlan] = useState(null);
  const [statusOperation, setStatusOperation] = useState(null);
  const [option, setOption] = useState(props.location.state?.option);
  const idProduct = props.match.params?.idProduct;
  const idOperation = props.match.params?.idOperation;

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const formik = useRef(Formik);

  // constante com ids e descrição dos campos do formulário
  const fieldQuestions = {
    CEP: "155",
    logradouro: "156",
    numero: "157",
    complemento: "158",
    cidade: "159",
    estado: "160",
    frmPagamento: "162",
    parcelamento: "181"
  };
  const initialvalues = {
    dtparcela: '',
    endCad: '',
    nmrcartao: '',
    ccv: '',
    nomecompleto: '',
    cpf: '',
    telefone: '',
    celular: '',
    confirmData: false,
    acceptTerms: false,
    155: [],
    156: "",
    157: "",
    158: "",
    159: "",
    160: "",
    162: "",
  }
  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Segunda-Feira",
    "Terça-Feira",
    "Quarta-Feira",
    "Quinta-Feira",
    "Sexta-Feira",
    "Sábado",
    "Domingo",
  ];
  const WEEKDAYS_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

  const getValidation = (value = null) => {

    let val = Yup.object().shape({
      ccv: value === 'CARTAO' ?
        (Yup.string().required('* Campo Obrigatório').min(3, 'Número inválido').max(3, 'Número Inválido'))
        :
        (Yup.string().notRequired()),
      cpf: value === 'CARTAO' ?
        (Yup.string().required('* Campo Obrigatório'))
        :
        (Yup.string().notRequired()),
      nmrcartao: value === 'CARTAO' ?
        (Yup.string().required('* Campo Obrigatório'))
        :
        (Yup.string().notRequired()),
      nomecompleto: value === 'CARTAO' ?
        (Yup.string().required('* Campo Obrigatório'))
        :
        (Yup.string().notRequired()),
      celular: Yup.string().required('* Campo Obrigatório'),
      162: verifyRequired(fieldQuestions.frmPagamento) ?
        Yup.string().required('* Campo Obrigatório')
        :
        (Yup.string().notRequired()),
      155: verifyRequired(fieldQuestions.CEP) ?
        Yup.string().required('* Campo Obrigatório')
        :
        (Yup.string().notRequired()),
      159: verifyRequired(fieldQuestions.cidade) ?
        Yup.string().required('* Campo Obrigatório')
        :
        (Yup.string().notRequired()),
      157: verifyRequired(fieldQuestions.numero) ?
        Yup.string().required('* Campo Obrigatório')
        :
        (Yup.string().notRequired()),
      156: verifyRequired(fieldQuestions.logradouro) ?
        Yup.string().required('* Campo Obrigatório')
        :
        (Yup.string().notRequired()),
      160: verifyRequired(fieldQuestions.estado) ?
        Yup.string().required('* Campo Obrigatório')
        :
        (Yup.string().notRequired()),
      confirmData: Yup.bool().required(() => { mc.error("aceite os termos"); }),
      acceptTerms: Yup.bool().required(() => { mc.error("aceite os termos"); })
    });
    setValidation(val);
  }

  const handleSubmit = (values) => {

    console.log(values);
    if (formik.current.values["confirmData"] === false || formik.current.values["acceptTerms"] === false) {
      mc.error("É necessário aceitar os termos e condições e confirmar a revisão dos Dados");
      return;
    };

    let personQst = [];
    let paymentQst = [];
    let adress;
    loading.start();
    //Montando questionarios com respostas
    questions.map(item => {
      let filteredItem = Object.keys(values).includes(item.idQuestion.toString());

      if (!!filteredItem) {
        let idAnswer = values[item.idQuestion].idAnswerOption ? values[item.idQuestion].idAnswerOption : null;
        let dsAnswer = values[item.idQuestion].dsAnswerOption ? values[item.idQuestion].dsAnswerOption : values[item.idQuestion];

        let qst = {
          idAnswerOption: idAnswer,
          idDomainPersonRole: item.idDomainPersonRoleQuestion,
          idQuestion: Number(item.idQuestion),
          idQuestionnaire: item.idQuestionaire,
          questionDomain: item.idDomainQuestion,
          textQuestionAnswer: dsAnswer
        };

        if (item.idQuestionaire == 20) {
          // person questionnarie
          if (qst.idQuestion === 155) {
            let unMaskZipCode = Mask.numbers(values[item.idQuestion]);
            qst.textQuestionAnswer = unMaskZipCode;
          }
          personQst.push(qst);
          return;
        }
        if (item.idQuestionaire == 23) {
          // payment questionnarie
          paymentQst.push(qst);
          return;
        }
      }
    });

    //Endereço do cliente
    adress = {
      zipcode: values[fieldQuestions.CEP],
      city: values[fieldQuestions.cidade],
      street: values[fieldQuestions.logradouro],
      complemento: values[fieldQuestions.complemento],
      num: values[fieldQuestions.numero],
      uf: values[fieldQuestions.estado],
    };

    const body = {
      coverageList: plan.coverageItems,
      coverageListSelected: null,
      firstInstallmentDate: stringToDate(values.dtparcela),
      idPlanCoverage: null,
      //id_personInsured: personRole.find(item => item.idPersonRole === 4).idPerson,
      id_product: idProduct,
      id_product_list: [],
      idProductPlan: plan.idProductPlan,
      idquoteop: idOperation,
      paymentMode: values[fieldQuestions.frmPagamento].dsAnswerOption,
      premium: plan.coverageAmount,
      selectedLim: plan.coverageLimit,
      planOption: option,
      adress: adress,
      email: quote.email,
      cpfOrCnpj: Mask.cpfCnpj(quote.cpfOrCnpj),
      proponent: quote.proponent,
      effectiveDate: stringToDate(quote.effectiveDate),
      retroactivity: quote.retroactivity,
      revenue_annual: quote.annualBilling,
      deductible: plan.deductibleDescription,
      //installment_number: values.planPayment ? values.planPayment : '7X sem juros = 0+7 de R$ 110,72',
      installment_number: quote?.installmentNumber?.answer,
      payment: paymentQst,
      persons: personQst
    };

    console.log("body issued: ", body);

    fitinsur.setAuthToken(authContext.token);
    //Submetendo questionario de Payment
    fitinsur.requestAddAction4(paymentQst, idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code != 200) {
          mc.error(`${response.ret_msg_details}`);
          console.log(response.JSON.stringify());
          loading.stop();
          return;
        }
        // Submetendo Issue
        fitinsur.requestIssueAction(body)
          .then(data => data.json())
          .then(response => {
            if (response[0].ret_code != 200) {
              mc.error(`${response.ret_msg_details}`);
              console.log(response.JSON.stringify());
              loading.stop();
              return;
            }
            mc.success(`Seguro enviado com sucesso`);
            loading.stop();
            history.push('/quotes');
          })
          .catch(err => {
            console.log(err);
            loading.stop();
          });
      })
      .catch(err => console.log(err));

  };

  function getDisableDate() {
    let dateBefore = new Date();
    let dateAfter = new Date();
    let weekday;
    let disableDate = { after: undefined, before: undefined };

    insurer === "fator" ?
      dateBefore.setDate(dateBefore.getDate() + 5)
      : dateBefore.setDate(dateBefore.getDate() + 10);
    console.log(dateBefore);
    weekday = dateBefore.getDay();
    console.log("dia da semana", weekday)

    weekday == 6 ?
      dateBefore.setDate(dateBefore.getDate() + 2)
      : weekday == 0 && dateBefore.setDate(dateBefore.getDate() + 1);

    disableDate.before = dateBefore;

    insurer === "fator" ? dateAfter.setDate(dateAfter.getDate() + 15)
      : dateAfter.setDate(dateAfter.getDate() + 30)

    weekday = dateAfter.getDay();
    console.log("dia da semana", weekday)

    weekday == 6 ?
      dateAfter.setDate(dateAfter.getDate() + 2)
      : weekday == 0 && dateAfter.setDate(dateAfter.getDate() + 1);

    console.log(dateAfter);
    disableDate.after = dateAfter;

    return disableDate;
  }

  const dayClick = (day, modifiers = {}) => {
    console.log("data", day);
    console.log("Mod", modifiers);
    if (modifiers.disabled == true) {
      return;
    }
    let dt = new Date(day);
    const stringdate = dt.toLocaleDateString('en-GB');
    formik.current.setFieldValue('dtparcela', stringdate)
    setShowCalendar(false);
  }

  const stringToDate = (string) => {
    let parts = string.split('/');
    let date = new Date(`${parts[1]}/${parts[0]}/${parts[2]}`);
    console.log('data formatada', date);
    return date;
  }

  const handleGetZipCode = (zipcode) => {

    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetAdressByZipCode(Mask.numbers(zipcode))
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error(`${response.ret_msg_details}`);
          console.log(response.JSON.stringify());
          loading.stop();
          return;
        }
        console.log('resultado Cep', response.ret_value);
        formik.current.setFieldValue(fieldQuestions.CEP, Mask.cep(response.ret_value.ZIP_CODE));
        formik.current.setFieldValue(fieldQuestions.cidade, response.ret_value.CITY);
        formik.current.setFieldValue(fieldQuestions.logradouro, response.ret_value.LONG_STREET_NAME);
        formik.current.setFieldValue(fieldQuestions.estado, response.ret_value.STATE);
        formik.current.setFieldValue('neighborhood', response.ret_value.DISTRICT);
        loading.stop();
      })
      .catch(err => {
        loading.stop();
        console.log(err)
      });

  };

  const handleCnpjAdress = (value) => {

    if (value == 'true') {
      loading.start();
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestSerproCnpj(quote.cpfOrCnpj)
        .then(data => data.json())
        .then(response => {
          if (response.ret_code !== 200) {
            mc.error(`${response.ret_msg_details}`);
            console.log(response.JSON.stringify());
            loading.stop();
            return;
          }
          const { endereco } = response.ret_value;
          formik.current.setFieldValue(fieldQuestions.CEP, Mask.cep(endereco.cep));
          formik.current.setFieldValue(fieldQuestions.cidade, endereco.municipio);
          formik.current.setFieldValue(fieldQuestions.logradouro, endereco.logradouro);
          formik.current.setFieldValue(fieldQuestions.complemento, endereco.complemento);
          formik.current.setFieldValue(fieldQuestions.numero, endereco.numero);
          formik.current.setFieldValue(fieldQuestions.estado, endereco.uf);
          formik.current.setFieldValue(fieldQuestions.neighborhood, endereco.bairro);

          loading.stop();
        })
        .catch(err => console.log(err));
    } else {
      formik.current.setFieldValue(fieldQuestions.CEP, '');
      formik.current.setFieldValue(fieldQuestions.cidade, '');
      formik.current.setFieldValue(fieldQuestions.logradouro, '');
      formik.current.setFieldValue(fieldQuestions.complemento, '');
      formik.current.setFieldValue(fieldQuestions.numero, '');
      formik.current.setFieldValue(fieldQuestions.estado, '');
      formik.current.setFieldValue(fieldQuestions.neighborhood, '');
    }

  };

  const verifyComponent = (fieldId) => {
    if (!questions) return;
    const question = questions.find(
      (item) => item.idQuestion.toString() === fieldId
    );
    if (question) {
      let behaviors = JSON.parse(question.behavior);

      if (question.idDomainQuestion === 42) return InputField;
      if (question.idDomainQuestion === 43) {
        if (behaviors.isComponentRelated)
          return behaviors.componentId === "RadioButton"
            ? RadioButtonGroup
            : SelectField;
        return SelectField;
      }
      if (question.idDomainQuestion === 44) return MultiSelectField;
      if (question.idDomainQuestion === 276) return SearchField;
      if (question.idDomainQuestion === 295) return InputField;
      if (question.idDomainQuestion === 277) return InputField;
    }
  };

  const verifyVisiblity = (fieldId) => {
    if (!questions) return;
    const question = questions.find(
      (item) => item.idQuestion.toString() === fieldId
    );
    if (question) {
      if (question?.questionVisible)
        return question.questionVisible == 1 ? false : true;
      return true;
    }
    return true;
  };

  const verifyRequired = (fieldId) => {
    if (!questions) return;
    const question = questions.find(
      (item) => item.idQuestion.toString() === fieldId
    );
    if (question) {
      if (question?.questionBehavior) {
        let behaviors = JSON.parse(question.questionBehavior);
        return behaviors.isRequired;
      }
    }
    return false;
  };

  const verifyOptions = (fieldId) => {
    if (!questions) return;
    const field = questions.find((f) => f.idQuestion.toString() == fieldId);
    if (field) {
      if (field.answerOptions) return fieldRenderOptions(field.answerOptions);
      return null;
    }
  };

  const getDsQuestion = (fieldId) => {
    if (!questions) return;
    const question = questions.find(
      (item) => item.idQuestion.toString() === fieldId
    );
    if (question) return question.dsQuestion;
  };

  const fieldRenderOptions = function (answerOptions) {
    let result = [];
    answerOptions.forEach((element) => {
      result.push({
        label: element.dsAnswerOption,
        value: {
          idAnswerOption: element.idAnswerOption,
          dsAnswerOption: element.dsAnswerOption,
        },
      });
    });
    return result;
  };


  function handleSelect(field) {
    formik.current.values[field] === true ? formik.current.setFieldValue(field, false)
      : formik.current.setFieldValue(field, true);
  }

  const changePlan = () => { history.push(`/quotes/plans/${idProduct}/${idOperation}`) };

  const getPayment = (insurer, coverageAmount) => {

    let installmentTotal;
    let options = [];
    installmentTotal = insurer === "Fator" ? 5 : 7;

    for (let index = 0; index < installmentTotal; index++) {

      let installmentValue = coverageAmount / (index + 1);
      let option = {
        label: index === 0 ? `Á vista` : `${index + 1}x Sem Juros de ` + `${Mask.currency({
          value: installmentValue,
          lang: "pt-br",
          currency: 'BRL',
          style: 'currency'
          })}`,         
        //label: index === 0 ? `Á vista` : `${index + 1}x Sem Juros`, // de ${coverageAmount / (index+1)}
        value: `${index + 1}`
      };

      //20210314 - minor fix - error "options not iterable" no componente selectField
      if (insurer === "Argo" && installmentValue < 100) {
        //return;
      } else {
        options.push(option);
      }
      //options.push(option);
    };

    return options;
  };

  useEffect(() => {
    async function requestGetQuoteFormatted() {
      if (authContext.status !== true) {
        mc.error("Usuário não autenticado");
        history.push('/login');
        return;
      }

      console.log('planplanplanplan', plan)

      getValidation();
      loading.start();
      fitinsur.setAuthToken(authContext.token);
      fitinsur
        .requestGetQuote(props.match.params.idProduct, props?.match?.params?.idOperation)
        // .requestGetQuote(15, 220791)
        .then((x) => x.json())
        .then((response) => {
          if (response.ret_code != 200) {
            mc.error(response.ret_msg_details);
            return loading.stop();
          }
          const { ret_value } = response;
          const getUniqObjBeetweenSames = (array) =>
            array
              .map((item) => ({
                answer: item.answer,
                idQuestion: item.idQuestion,
                dsQuestion: item.dsQuestion,
              }))
              .filter(
                (item, pos, self) =>
                  self.findIndex(
                    (v) =>
                      v.answer === item.answer &&
                      item.idQuestion == v.idQuestion
                  ) === pos
              );
          const risks = getUniqObjBeetweenSames(ret_value.risks);
          const operations = getUniqObjBeetweenSames(ret_value.operations);
          const payments = getUniqObjBeetweenSames(ret_value.payments);
          const questionaries = [...questions, ...ret_value.payments, ...ret_value.persons];
          setQuestions(questionaries);
          setStatusOperation(ret_value.operation.idDomainStatus);
          let planSelect = ret_value.operation.idProductPlan;
          const searshplan = ret_value.resultProductPlans.product_plan.find(plans => plans.id_product_plan === planSelect)
          const SelectedPlanName = searshplan.product_plan_name;
          SelectedPlanName.indexOf('Argo') > 0 ? setInsurer('argo') : setInsurer('fator');
          const mapCoverages = ret_value.resultProductPlans.coverageCalc
            .map((item) => [
              ...item.coverageCalc.map((coverage) => ({
                ...coverage,
                idProductPlan: item.id_product_plan,
              })),
            ])
            .flat();
          const flatCoverages = mapCoverages.map((item) => item.coverageLimit);
          const limits = flatCoverages.filter(
            (item, index, self) => self.indexOf(item) == index
          );
          const coverages = limits.map((limit) => {
            const plans = mapCoverages
              .map((item) => (item.coverageLimit == limit ? item : false))
              .filter(Boolean);
            return {
              limit,
              plans,
            };
          });
          setQuote({
            idOperation: ret_value.idOperation,
            proponent: ret_value.persons.find((item) => item.idQuestion == 145)
              .answer,
            email: ret_value.persons.find((item) => item.idQuestion == 144)
              .answer,
            cpfOrCnpj: ret_value.persons.find((item) => item.idQuestion == 143)
              .answer,
            previousInsurer: operations.find(
              ({ idQuestion }) => idQuestion == 148
            ).answer,
            susep: ret_value.persons.find((item) => item.idQuestion == 146)
              .answer,
            marketingBranches: risks
              .map(({ idQuestion, answer }) =>
                idQuestion == 150 ? answer : false
              )
              .filter(Boolean),
            sufferedComplaintsFiveYears: risks.find(
              ({ idQuestion }) => idQuestion == 152
            ).answer,
            possibleComplaints: risks.find(
              ({ idQuestion }) => idQuestion == 153
            ).answer,
            effectiveDate: risks.find(({ idQuestion }) => idQuestion == 154)
              .answer,
            retroactivity: risks.find(({ idQuestion }) => idQuestion == 163)
              .answer,
            annualBilling: risks.find(({ idQuestion }) => idQuestion == 149)
              .answer,
            transportBilling: risks.find(({ idQuestion }) => idQuestion == 151)
              .answer,
            product_plans: ret_value.resultProductPlans.product_plan,
            coverages,
            limits,
            installmentNumber: payments.find(({ idQuestion }) => Number(idQuestion) == Number(fieldQuestions.parcelamento))
          });
          setPlan(ret_value.operation.metadata.currentPlan);
          setOption(ret_value.operation.metadata.optionLabel);
          loading.stop();
        })
        .catch((e) => {
          loading.stop();
          console.log(e);
        });
    }
    requestGetQuoteFormatted();
    console.log("Questions person e pgmt", questions)

  }, []);

  return (
    <Layout title='Nova Cotação' subtitle='Responsabilidade Civil Profissional Corretor de Seguros'>
      <Content>
        <Subtitle
          idProduct={idProduct}
          stage={3}
          idOperation={idOperation}
          statusOperation= {statusOperation}
        />
        <BrokingSummary data={quote} />
        <Modal visible={showTerms} setVisible={setShowTerms}>
          <h4>Termos e Condições</h4>
          <p>
            Declaro que as informações acima são verdadeiras e que estou ciente de que, em caso de sinistro, se for verificado que as informações, que serviram de base para a contratação e fixação do custo do seguro, forem inexatas, a indenização poderá ser reduzida ou negada pela seguradora.
          </p>
          <p>
            A empresa proponente deve notificar a seguradora, o mais rápido possível, sobre qualquer alteração das informações contidas neste questionário, ocorridas antes do início da vigência do seguro. Nesse caso, a seguradora poderá, a seu critério, modificar ou cancelar a cotação de seguro anteriormente
            enviada.
          </p>
          <p>
            A seguradora fica autorizada a fazer qualquer investigação ou pergunta relacionada ao risco, na medida em que julgue necessária.
          </p>
          <AceptContainer>
            <Button primary onClick={() => {
              formik.current.setFieldValue('acceptTerms', true);
              setShowTerms(false)
            }}>
              ACEITAR
            </Button>
          </AceptContainer>
        </Modal>

        <Formik
          initialValues={initialvalues}
          onSubmit={(values) => handleSubmit(values)}
          innerRef={formik}
          validationSchema={validation}
        >
          {(formikProps) => (
            <Form>
              {/* <Modal show={showTerms}> */}
              <Row>
                <Col md={3}>
                  <ContentCard
                    title={`OPÇÃO ${option}`}
                    noBorder
                    noPadding
                    customShadow={`box-shadow: 0px 8px 12px 0px ${Colors.GRAY[4]};`}
                    rightTitle="Alterar"
                    action={changePlan}
                  //mr={12}
                  >

                    <Col md={12}>
                      <Logo src={insurer === 'argo' ? LogoArgo : LogoFator} />
                      <Label>
                        Limite (Valor Segurado):
                      </Label>
                      <label>
                        {plan && Mask.currency({
                          value: plan.coverageLimit,
                          lang: "pt-br",
                          currency: 'BRL',
                          style: 'currency'
                        })}
                      </label>
                      <Label>
                        Prêmio Líquido
                      </Label>
                      <label>
                        {plan && Mask.currency({
                          value: plan.coverageAmountTaxLess,
                          lang: "pt-br",
                          currency: 'BRL',
                          style: 'currency'
                        })}
                      </label>
                      <Label>
                        IOF
                      </Label>
                      <label>{plan && Mask.currency({
                        value: plan.coverageTax,
                        lang: "pt-br",
                        currency: 'BRL',
                        style: 'currency'
                      })}</label>
                      <Label>
                        Prêmio Total (Valor a ser Pago)
                      </Label>
                      <label>
                        {plan && Mask.currency({
                          value: plan.coverageAmount,
                          lang: "pt-br",
                          currency: 'BRL',
                          style: 'currency'
                        })}
                      </label>
                      <Label>
                        Franquia
                      </Label>
                      <label>{plan && plan.deductibleDescription}</label>
                      {/* <label>plan.payment adicionar parametro do pagamento 7X sem juros = 0+7 de R$ 110,72</label>*/}
                      {
                        /*
                      <Field
                        name="planPayment"
                        placeholder="Parcelamento"
                        label="Parcelamento Selecionado:"
                        component={SelectField}
                        options={getPayment(insurer === 'argo' ? 'Argo' : 'Fator', plan?.coverageAmount)}
                      />                        
                        */
                      }
                      <Label>
                        Parcelamento Selecionado:
                      </Label>                      
                      <label>{quote?.installmentNumber?.answer}</label>
                    </Col>
                  </ContentCard>
                </Col>

                <Col md={9}>
                  <ContentCard
                    title="Dados de Pagamento"
                    noBorder
                    customShadow={`box-shadow: 0px 8px 12px 0px ${Colors.GRAY[4]};`}
                  >
                    <Fieldset>
                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.frmPagamento}
                            label={getDsQuestion(fieldQuestions.frmPagamento)}
                            component={verifyComponent(fieldQuestions.frmPagamento)}
                            options={verifyOptions(fieldQuestions.frmPagamento)}
                            onChange={(value) => getValidation(value)}
                          />
                        </Col>
                        <Col md={6}>
                          <Field
                            name='dtparcela'
                            label='Data da primeira Parcela'
                            type="text"
                            component={InputField}
                            rightIcon="calendar"
                            rightIconClick={() => setShowCalendar(!showCalendar)}
                            readOnly
                          />
                          {showCalendar && <CalendarContainer>
                            <DayPicker
                              disabledDays={[
                                getDisableDate(),// { daysOfWeek: [0, 6] }
                              ]}
                              showOutsideDays
                              onDayClick={dayClick}
                              months={MONTHS}
                              weekdaysLong={WEEKDAYS_LONG}
                              weekdaysShort={WEEKDAYS_SHORT}
                              firstDayOfWeek={0}
                              fixedWeeks
                            />
                          </CalendarContainer>}
                        </Col>
                      </Row>
                      <CardInfo card={formikProps.values.formapgmt === 'CARTAO' ? true : false}>
                        <Row>
                          <Col>
                            <Field
                              name='nmrcartao'
                              label='Numero do Cartão'
                              component={InputField}
                              onChange={(value) => formikProps.setFieldValue('nmrcartao', Mask.creditCard(value))}
                            />
                          </Col>
                          <Col>
                            <Field
                              name='ccv'
                              label='CCV'
                              component={InputField}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Field
                              name='nomecompleto'
                              label='Nome Completo'
                              component={InputField}
                            />
                          </Col>
                          <Col>
                            <Field
                              name='cpf'
                              label='CPF'
                              component={InputField}
                              onChange={(value) => formikProps.setFieldValue('cpf', Mask.cpf(value))}
                            />
                          </Col>
                        </Row>
                      </CardInfo>
                    </Fieldset>
                    <Fieldset>
                      <Row>
                        <Line />
                        <Col md={10}>
                          <Field
                            name='endCad'
                            label='O endereço de cadastro é o mesmo de cobrança?'
                            component={RadioButtonGroup}
                            options={[{ label: 'Sim', value: 'true' }, { label: 'Não', value: 'false' }]}
                            onChange={(value) => handleCnpjAdress(value)}
                            row
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <Field
                            name={fieldQuestions.CEP}
                            label={getDsQuestion(fieldQuestions.CEP)}
                            component={verifyComponent(fieldQuestions.CEP)}
                            onChange={(value) => formikProps.setFieldValue(fieldQuestions.CEP, Mask.cep(value))}
                            value={formikProps.values[fieldQuestions.CEP]}
                            rightIconClick={(value) => handleGetZipCode(value)}
                            readOnly={formikProps.values.endCad === 'true' ? true : false}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={10}>
                          <Field
                            name={fieldQuestions.logradouro}
                            label={getDsQuestion(fieldQuestions.logradouro)}
                            component={verifyComponent(fieldQuestions.logradouro)}
                            readOnly={formikProps.values.endCad === 'true' ? true : false}
                          />
                        </Col>
                        <Col md={2}>
                          <Field
                            name={fieldQuestions.numero}
                            label={getDsQuestion(fieldQuestions.numero)}
                            component={verifyComponent(fieldQuestions.numero)}
                            readOnly={formikProps.values.endCad === 'true' ? true : false}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.cidade}
                            label={getDsQuestion(fieldQuestions.cidade)}
                            component={verifyComponent(fieldQuestions.cidade)}
                            readOnly={formikProps.values.endCad === 'true' ? true : false}
                          />
                        </Col>
                        <Col md={4}>
                          <Field
                            name={fieldQuestions.complemento}
                            label={getDsQuestion(fieldQuestions.complemento)}
                            component={verifyComponent(fieldQuestions.complemento)}
                          />
                        </Col>
                        <Col md={2}>
                          <Field
                            name={fieldQuestions.estado}
                            label={getDsQuestion(fieldQuestions.estado)}
                            component={verifyComponent(fieldQuestions.estado)}
                            readOnly={formikProps.values.endCad === 'true' ? true : false}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Field
                            name='telefone'
                            label='Telefone'
                            component={InputField}
                            onChange={(value) => formikProps.setFieldValue('telefone', Mask.tel(value))}
                          />
                        </Col>
                        <Col md={6}>
                          <Field
                            name='celular'
                            label='Celular'
                            component={InputField}
                            onChange={(value) => formikProps.setFieldValue('celular', Mask.tel(value))}
                          />
                        </Col>
                      </Row>

                    </Fieldset>
                  </ContentCard>
                  <Row>
                    <Col sm={12} md={12} lg={12}>
                      <Label>
                        <CheckBox
                          value={formikProps.values.confirmData}
                          checked={formikProps.values.confirmData}
                          onChange={() => handleSelect('confirmData')}
                        />
                        Confirmo que Revisei os Dados Preenchidos e Autorizo a Emissão do Seguro.
                      </Label>
                      <Row>
                        <Label>
                          <CheckBox
                            value={formikProps.values.acceptTerms}
                            checked={formikProps.values.acceptTerms}
                            onChange={() => handleSelect('acceptTerms')}
                          />
                        Concordo que Li e Aceito os
                        </Label>
                        <Label onClick={() => setShowTerms(true)}>
                        &nbsp;<u>Termos e Condições</u>&nbsp;
                        </Label>
                        <Label>
                          apresentados.
                        </Label>
                      </Row>
                    </Col>
                  </Row>
                  <ButtonContainer>
                    <Button onClick={() => history.goBack()}
                    >
                      &lt; Voltar
                    </Button>
                    <Button primary type='submit'>
                      CONFIRMAR
                    </Button>
                  </ButtonContainer>
                </Col>
              </Row>

            </Form>
          )}
        </Formik>

      </Content>
    </Layout >
  );
}
